export const BOOLEAN_TRUE = '==='
export const BOOLEAN_FALSE = '!=='

export const booleanOperators = Object.freeze({
    true: {
        key: BOOLEAN_TRUE,
        label: 'Yes',
        json: {
            getLogic: (a) => ({
                [BOOLEAN_TRUE]: [{'var': a}, true]
            }),
            getData: () => null
        }
    },
    false: {
        key: BOOLEAN_FALSE,
        label: 'No',
        json: {
            getLogic: (a) => ({
                [BOOLEAN_FALSE]: [{'var': a}, true]
            }),
            getData: () => null
        }
    }
})

export const booleanOperatorsList = Object.freeze(Object.values(booleanOperators))
